import Header from "../navigation/headerContainer";
import AuctionsContainer from "./auctionContainer";
import Footer from "../navigation/footerContainer";


export default function AuctionsPage(){

    return(
        <>
            <Header />
            <AuctionsContainer />
            <Footer />
        </>
    )

}